<template>
  <div class="nf-container">
    <h1 class="nf-code">404</h1>
    <p class="nf-text">This page seems to have drifted off into a trance.</p>
    <router-link to="/" class="download-btn">Back to Home</router-link>
  </div>
</template>

<script setup>
// static page
</script>

<style scoped>
.nf-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 120px 20px 60px;
}
.nf-code {
  font-family: 'Pacifico', cursive;
  font-size: clamp(64px, 12vw, 110px);
  font-weight: 400;
  color: #ff3d82;
  margin: 0 0 8px;
  text-shadow: 2px 3px 0px rgba(255, 100, 150, 0.25);
}
.nf-text {
  color: #391a67;
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
</style>
